import type { FC, ReactNode } from 'react';
import React, { createContext, useContext } from 'react';
import type { VeloConfig } from '@wix/cli-site-old-definitions';
import { loadVeloConfig, saveVeloConfig } from './files/velo.config.js';

export interface ProjectModel {
  projectFolder: string;
  metaSiteId: string;
  revision: string;
}

export async function loadProjectModel(
  projectFolder: string
): Promise<ProjectModel> {
  const config = await loadVeloConfig(projectFolder);
  return {
    projectFolder,
    metaSiteId: config.siteId,
    revision: config.uiVersion,
  };
}

export async function saveProjectModel(model: ProjectModel): Promise<void> {
  const config: VeloConfig = {
    siteId: model.metaSiteId,
    uiVersion: model.revision,
  };

  await saveVeloConfig(model.projectFolder, config);
}

interface ProjectModelState {
  model: ProjectModel;
}

const ProjectModelContext = createContext<ProjectModelState | null>(null);

interface Props {
  value: ProjectModel;
  children: ReactNode;
}

export const ProjectModelProvider: FC<Props> = ({ value: model, children }) => {
  return (
    <ProjectModelContext.Provider value={{ model }}>
      {children}
    </ProjectModelContext.Provider>
  );
};

export function useProjectModel(): ProjectModelState {
  const context = useContext(ProjectModelContext);
  if (context == null) {
    throw new Error(
      'useProjectModel() cannot be used without an <ProjectModelProvider>'
    );
  }
  return context;
}
